import * as charts from "../../charts/";
import { ChartType } from "../../entities/reportEntity";

export default {
  id: 102,
  label: "IPC年度申请趋势分析",
  chart: charts.lineAndBar2D,
  definition: {
    rowDims: [{ name: "ipcName", label: "IPC分类", limit: 10, table: "patent_ipc", needTotal: true }],
    colDims: [{ name: "appDate", label: "申请年", dateUnit: "YEAR", limit: 10, needTotal: true }],
    measures: [{ name: "count", label: "专利量", sortBy: "DESC" }],
    showNoDataDims: true
  },
  chartOption: {
    chartType: ChartType.LINE,
    title: "IPC年度申请趋势分析",
    subTitle: "",
    hideTitle: false,
    xaxisTitle: "",
    yaxisTitle: "",
    hideAxisTitle: true,
    hideLabel: true,
    hideLegend: false,
    hideToolbox: false
  }
};
